import React, { useState, useEffect, useRef } from "react";
import ClientThankYou from "./ClientThankYou";
import CandidateThankYou from "./CandidateThankYou";



const InsuffFulfilThankyouPage=()=>{

 
    useEffect(()=>{
     
        setTimeout(() => {
            autoLogout()
        }, 5000);
    },[])

    const autoLogout = () => {
        localStorage.removeItem("tokenVerification");
        localStorage.removeItem("userVerificationCandidate");
        window.location = "login";
  }

    return(
        <>
        <CandidateThankYou/>
        </>
    )
}

export default InsuffFulfilThankyouPage;